import React, { useRef, useState } from 'react';
import useStyles from './styles';
import { useTheme } from 'react-jss';
import { Option } from '../Option';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import { ClickAwayListener } from '../ClickAwayListener';
import clsx from 'clsx';
import { Icons } from '../../types/icons';
const Select = ({ options, onSelect, label, selected, placeholder = 'Selecione', customClassName = '', inlineStyles = {}, }) => {
    const theme = useTheme();
    const classes = useStyles({ theme });
    const [open, setOpen] = useState(false);
    const self = useRef(null);
    const toggle = () => setOpen(b => !b);
    const isSelected = Boolean(selected);
    const containerStyles = clsx({
        [classes.container]: true,
        [customClassName]: Boolean(customClassName)
    });
    const labelStyle = clsx({
        [classes.label]: true,
        [classes.placeholder]: !isSelected
    });
    return (React.createElement("div", { className: containerStyles, style: inlineStyles },
        React.createElement("span", { className: classes.label, onClick: toggle },
            React.createElement(Typography, { variant: 'content2', center: true }, label)),
        React.createElement("div", { className: classes.input, ref: self, onClick: toggle },
            React.createElement(Typography, { variant: 'content2', customClassName: labelStyle }, isSelected ? selected.label : placeholder),
            React.createElement(Icon, { name: !open ? Icons.CaretDown : Icons.CaretUp, fill: isSelected ? '#4b4b4b' : '#acacac', customClassName: classes.icon }),
            open &&
                React.createElement(ClickAwayListener, { onClickAway: () => setOpen(false) },
                    React.createElement("div", { className: classes.options }, options.map(option => (React.createElement(Option, { key: option.id, option: option, onSelectOption: onSelect, active: option.id === (selected === null || selected === void 0 ? void 0 : selected.id) }))))))));
};
export { Select };
//# sourceMappingURL=Select.js.map